const endPoints = {
  entity: (id = '') => `entities/${id}`,
  entityContactEmail: (entityId, id = '') => `entities/${entityId}/entity-contact-emails/${id}`,
  entityPerson: (entityId, id = '') => `entities/${entityId}/persons/${id}`,
  account: () => `accounts`,
  user: (id = '') => `users/${id}`,
}

export default endPoints
